import { CellInfo } from 'react-table-6';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { fn0nZ, fn2nZ } from '../../../core/formatter/formatNumber';
import { getCustomFormConfig } from '../co2_custom/getCustomFormConfig';
import { IDs } from '../../../helpers/IDs';
import { isValid as isValidMaschinen } from '../../../main/functions/validData';
import { lazyInject } from '../../../services/inversify';
import { MaschinenDetail } from './MaschinenDetail';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { validateFieldUniversal } from '../functions/validateField';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WMap } from '../map/Wmap';
import { ZusatztoolsImport } from '../../zusatztools/ZusatztoolsImport';
import myStyle from './StandorteMaschinen.less';

export interface StandorteMaschinenProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

export interface StandorteMaschinenState {
    beforeImportTids: any[];
    hiddenFormFields: any[];
    rowForDialog: any;
    rowForGps: any;
    showBeleuchtungsTool: boolean;
    showImportTool: boolean;
    zusammenfassen: any;
    filter: any[];
    leftGesamt: number;
    widthGesamt: number;
    validRestriction: string;
}

export class StandorteMaschinen extends React.Component<StandorteMaschinenProps, StandorteMaschinenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            beforeImportTids: [],
            hiddenFormFields: [],
            rowForDialog: undefined,
            showBeleuchtungsTool: false,
            showImportTool: false,
            rowForGps: undefined,
            zusammenfassen: {},
            filter: [],
            leftGesamt: null,
            widthGesamt: null,
            validRestriction: null
        };
        this.customFormatter = this.customFormatter.bind(this);
        this.onAfterClose = this.onAfterClose.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.onSaveDone = this.onSaveDone.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
        this.customFormConfigFunc = this.customFormConfigFunc.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    private formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
    private refDiv = React.createRef<HTMLDivElement>();

    checkImport(): void {
        const isFalse: boolean = ((this.props.data || {})[IDs.ENT_MASCHINEN] || []).some((item: any) =>
            this.state.beforeImportTids.indexOf(item.tid) === -1 && !(item.energiedaten_waerme_energietraeger_tid || '').length
        );
        this.setState(
            { beforeImportTids: [], showImportTool: false },
            () => isFalse ? alert('Es wurde mind. ein Datensatz ohne Energieträger importiert!') : null
        );
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        const color: React.CSSProperties = (!data || +data.status || null) === 2 ? { color: '#aaa' } : {};

        if (field === 'energiedaten_waerme_energietraeger_tid' && !(value || '').length) {
            return (
                <div style={{ backgroundColor: '#fee', height: '100%', outline: '2px solid #fee', ...color }}>
                    {value}
                </div>
            );
        }

        if (field === 'leistung') {
            return typeof value === 'number' ? this.formatFloat.format(value) : value;
        }

        if (field === 'messwert_unterzaehler') {
            return (
                <div style={{ textAlign: 'right', backgroundColor: '#ccc', height: '100%', outline: '2px solid #ccc', ...color }}>
                    {typeof value === 'number' ? this.formatFloat.format(value) : value}
                </div>
            );
        }

        if (Object.keys(color).length) {
            return <span style={color}>{value}</span>;
        }

        return value;
    }

    getCustomColumns(): any[] {
        return ([
            {
                accessor: 'energieverbrauch',
                Header: 'Energievebrauch (geschätzt)',
                HeaderText: 'Energievebrauch (geschätzt)',
                id: 'energieverbrauch',
                filterable: false,
                Cell: (row: CellInfo) => {
                    const data: any = row.original || {};
                    const leistung: number = data.leistung || null;
                    const betriebszeit_h_tag: number = data.betriebszeit_h_tag || null;
                    const betriebszeit_tage_jahr: number = data.betriebszeit_tage_jahr || null;
                    const auslastungsfaktor: number = data.auslastungsfaktor || null;
                    const _energieverbrauch: number = data._energieverbrauch || null;
                    const energieverbrauch: number = this.getEnergieverbrauch(
                        leistung, betriebszeit_h_tag, betriebszeit_tage_jahr, (+auslastungsfaktor / 100)
                    ) || _energieverbrauch || 0;
                    return (
                        <div style={{ textAlign: 'right', backgroundColor: '#ccc', height: '100%', outline: '2px solid #ccc' }}>
                            {fn2nZ(energieverbrauch)}
                        </div>
                    );
                }
            }
        ]);
    }

    getEnergieverbrauch(leistung: number, betriebszeit_h_tag: number, betriebszeit_tage_jahr: number, auslastungsfaktor: number): number {
        return +leistung * +betriebszeit_h_tag * +betriebszeit_tage_jahr * +auslastungsfaktor;
    }

    getLastDataYear(): any {
        const standort: any = this.props.standortSelected || {};
        const standort_tid: number = standort.tid || null;
        const startjahr: number = +((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || 2010;
        const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort_tid]
            || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
        let strom: any = null;
        let waerme: any = null;

        Object.keys(kennzahlen).sort((a: string, b: string) => +b - +a).forEach((key: string) => {
            if (!isNaN(+key)) {
                const data: any = kennzahlen[key] || {};
                const jahr: number = data.jahr || null;
                if (+jahr < startjahr || (strom && waerme)) {
                    return;
                }
                strom = strom === null && data.strom_verbrauch_gesamt
                    ? { jahr, total: data.strom_verbrauch_gesamt }
                    : strom;
                waerme = waerme === null && data.waerme_kwh
                    ? { jahr, total: data.waerme_kwh }
                    : waerme;
            }
        });

        return { strom, waerme };
    }

    onAfterClose(): void {
        this.setState({ rowForDialog: undefined });
    }

    onDataLoaded(data: any[]): void {
        this.setState({ filter: this.preFilter(data) });

        if (this.state.widthGesamt) {
            return;
        }

        if (!this.refDiv.current || !this.refDiv.current.children.length) {
            return;
        }
        const row: HTMLElement = this.refDiv.current.children[0].querySelector('div.ReactTable div.rt-thead div.rt-tr');
        const width: number = window.innerWidth;
        let leftAbwaerme: number = null;
        let leftEnergietraeger: number = null;

        if (!this.state.widthGesamt && row !== null && row.children.length > 10) {
            const tdAbwaerme: DOMRect = row.children[11].getBoundingClientRect();
            const tdEnergietraeger: DOMRect = row.children[4].getBoundingClientRect();
            leftAbwaerme = +tdAbwaerme.left || null;
            leftEnergietraeger = +tdEnergietraeger.left || null;
        }
        this.setState({
            leftGesamt: width < +leftAbwaerme ? 0 : +leftEnergietraeger,
            widthGesamt: width < +leftAbwaerme ? width : leftAbwaerme - +leftEnergietraeger
        });
    }

    onSaveDone(entityName: string, values: any): void {
        this.triggerService.fire('reload', entityName);
        const filter: any[] = this.state.filter || [];
        const index: number = filter.findIndex((item: any) => item.tid === values.tid);

        if (index !== -1) {
            filter[index] = values || {};
            this.setState({ filter });
        }
    }

    preFilter(data: any[]): any {
        const { standortSelected } = this.props;
        const dataSummen: any = {};
        const arrSummen: any[] = [];

        const dataFiltered1: any[] = standortSelected
            ? data.filter((item: any) => (+item.standort_tid_orig || null) === standortSelected.tid)
            : data;
        // console.log('Prefilter ..', this.state.zusammenfassen);
        const dataFiltered2: any = dataFiltered1.filter((item: any) => {
            const isValid: boolean = isValidMaschinen(item, IDs.ENT_MASCHINEN, this.props.data);
            const type: number = item.maschinen_typ_tid_orig;
            const zs: boolean = this.state.zusammenfassen[type];
            const status: number = item.status || null;
            const leistung: number = (isValid && status !== 2) ? +item.leistung : 0;
            const betriebszeit_h_tag: number = (isValid && status !== 2) ? +item.betriebszeit_h_tag : 0;
            const betriebszeit_tage_jahr: number = (isValid && status !== 2) ? +item.betriebszeit_tage_jahr : 0;
            const auslastungsfaktor: number = (isValid && status !== 2) ? +item.auslastungsfaktor : 0;
            const messwert_unterzaehler: number = (isValid && status !== 2) ? +item.messwert_unterzaehler : 0;
            const energieverbrauch: number = this.getEnergieverbrauch(
                leistung, betriebszeit_h_tag, betriebszeit_tage_jahr, (auslastungsfaktor / 100)
            );
            if (zs) { // Ja zusammenfassen --> Immer für Standort, Typ und Energieträger
                const standort: number = item.standort_tid_orig;
                const energietraeger: number = item.energiedaten_waerme_energietraeger_tid_orig;
                const key: string = `${standort}_${energietraeger}_${type}`;

                if (!dataSummen[key]) {
                    dataSummen[key] = {
                        energiedaten_waerme_energietraeger_tid: item.energiedaten_waerme_energietraeger_tid,
                        standort_tid: item.standort_tid,
                        leistung,
                        // leistung: item.leistung,
                        maschinen_typ_tid: item.maschinen_typ_tid,
                        name: <b>Summe</b>,
                        baujahr: '',
                        bemerkung: '',
                        latitude: 0,
                        longitude: 0,
                        foto: 0,
                        messsystem: null,
                        kalibrierung: null,
                        unterzaehler_vorhanden: 0,
                        abwaerme: 0,
                        messwert_unterzaehler,
                        _energieverbrauch: messwert_unterzaehler > 0 ? 0 : energieverbrauch,
                        _noActions: true
                    };
                    arrSummen.push(dataSummen[key]);
                } else {
                    dataSummen[key].leistung += leistung;
                    dataSummen[key]._energieverbrauch += messwert_unterzaehler > 0 ? 0 : energieverbrauch;
                    dataSummen[key].messwert_unterzaehler += messwert_unterzaehler;
                }
            }
            return !zs;
        });
        // console.log('DF ', dataFiltered2, arrSummen);
        return [...dataFiltered2, ...arrSummen];
    }

    render(): JSX.Element {
        const standort: any = this.props.standortSelected || {};
        const standort_tid: number = standort.tid || null;
        const typen: any[] = (this.props.data[IDs.ENT_MASCHINEN_TYPEN] || []).filter((typ: any) => typ.name !== 'Heizung');
        const check_zusammenfassung = typen.map((typ: any, idx: number) =>
            <div
                className={myStyle.tableButton}
                key={`typ-${idx}`}
                onClick={() => {
                    const zusammenfassen = this.state.zusammenfassen;
                    zusammenfassen[typ.tid] = !zusammenfassen[typ.tid];
                    this.setState({ zusammenfassen });
                }}
            >
                <input
                    type='checkbox'
                    checked={this.state.zusammenfassen[typ.tid] ? true : false}
                    onChange={(evt: any) => {
                        const zusammenfassen = this.state.zusammenfassen;
                        zusammenfassen[typ.tid] = evt.target.checked;
                        this.setState({ zusammenfassen });
                    }}
                />
                <div style={{ paddingTop: 2 }}>
                    {typ.name} zusammenfassen
                </div>
            </div>
        );

        return (
            <div ref={this.refDiv}>
                {!this.state.showImportTool &&
                    <>
                        <WFormsTableWrapper
                            entity={IDs.ENT_MASCHINEN}
                            module={IDs.MOD_ETOOL}
                            actions={['add', 'edit', 'delete']}
                            customClass='Custom-ETA'
                            formLayout='flowV2'
                            addLabel='Maschine/Anlage erfassen'
                            formPreset={{ ...(standort_tid !== null ? { standort_tid: standort_tid } : {}) }}
                            hiddenFormFields={this.state.hiddenFormFields}
                            // customActions={customActions}
                            customColumns={this.getCustomColumns()}
                            tableOrder={[
                                'standort_tid', 'name', 'maschinen_typ_tid', 'baujahr', 'energiedaten_waerme_energietraeger_tid',
                                'unterzaehler_vorhanden', 'leistung', 'betriebszeit_h_tag', 'betriebszeit_tage_jahr',
                                'auslastungsfaktor', 'energieverbrauch'
                            ]}
                            customFormConfig={getCustomFormConfig(IDs.ENT_MASCHINEN, this.state.rowForDialog, this.props.data)}
                            customFormConfigFunc={this.customFormConfigFunc}
                            // customFormConfig={{ standort_tid: { readonly: standort_tid !== null } }}
                            customFormatter={this.customFormatter}
                            // summaryCondition={(row: any) => (row.status || null) !== 2}
                            externalHeaderElements={[this.renderImportButton(), ...check_zusammenfassung]}
                            preFilterFunction={this.preFilter}
                            onFilterChange={(filter: any[], data: any) =>
                                this.setState({ filter: data.map((row: any) => row._original) })
                            }
                            validateField={this.validateField}
                            validRestriction={this.state.validRestriction}
                            callBeforeOnFormSave={(data: any, callback: () => void) =>
                                this.setState(
                                    { validRestriction: !isValidMaschinen(data || {}, IDs.ENT_MASCHINEN, this.props.data, true) ? 'stop' : null },
                                    () => callback()
                                )
                            }
                            tablePageSize={10}
                            onSaveDone={this.onSaveDone}
                            onDelDone={() => this.triggerService.fire('reload', IDs.ENT_MASCHINEN)}
                            onDataLoaded={this.onDataLoaded}
                        />
                        {this.state.widthGesamt &&
                            this.renderGesamt()
                        }
                    </>
                }
                {this.state.rowForDialog &&
                    <DialogWrapper2
                        onAfterClose={this.onAfterClose}
                    >
                        <MaschinenDetail
                            data={this.props.data}
                            maschineSelected={this.state.rowForDialog}
                        />
                        <div style={{ textAlign: 'right', marginRight: 4 }}>
                            {this.renderCloseButton()}
                        </div>
                    </DialogWrapper2>
                }
                {this.state.showBeleuchtungsTool &&
                    <DialogWrapper2
                        onAfterClose={() => this.setState({ showBeleuchtungsTool: false })}
                    >
                        <div style={{ width: 400 }}>
                            An dieser Stelle wird später das Beleuchtungs-Tool zur Verfügung gestellt.
                        </div>
                    </DialogWrapper2>
                }
                {this.state.rowForGps &&
                    <DialogWrapper2
                        width={530}
                        onAfterClose={() => this.setState({ rowForGps: undefined })}
                    >
                        <WMap
                            lat={this.state.rowForGps.latitude ? this.state.rowForGps.latitude : null}
                            long={this.state.rowForGps.longitude ? this.state.rowForGps.longitude : null}
                            data={this.state.rowForGps}
                            entity={IDs.ENT_MASCHINEN}
                            edittable={true}
                            onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_MASCHINEN)}
                        />
                    </DialogWrapper2>
                }
                {this.state.showImportTool &&
                    this.renderImport()
                }
            </div>
        );
    }

    renderCloseButton(): JSX.Element {
        return (
            <WActionButton
                label='Schließen'
                insideText='Schließen'
                key='close'
                action='delete'
                onAction={this.onAfterClose}
            />
        );
    }

    renderGesamt(): JSX.Element {
        const cell: React.CSSProperties = { backgroundColor: '#ccc', padding: '4px 2px', border: 0, borderTop: '1px solid white' };
        const cell2: React.CSSProperties = { ...cell, borderTopWidth: 15 };
        const data: any = this.getLastDataYear() || {};
        const waerme_energietraeger: any[] = (this.props.data[`${IDs.ENT_MASCHINEN}_bundle`] || {})
            .energiedaten_waerme_energietraeger_tid || [];
        data.strom = { ...data.strom || {} };
        data.waerme = { ...data.waerme || {} };
        data.strom.verbrauch = 0;
        data.waerme.verbrauch = 0;

        (this.state.filter || []).forEach((maschine: any) => {
            if (!maschine._noActions && (!isValidMaschinen(maschine, IDs.ENT_MASCHINEN, this.props.data) || (+maschine.status || null) === 2)) {
                // _noActions = Summe
                // console.log('Masch: INVALID: ', maschine);
                return;
            } else {
                // console.log('Masch: VALID: ', maschine);
            }
            const energietraeger_tid: number = maschine.energiedaten_waerme_energietraeger_tid_orig
                || maschine.energiedaten_waerme_energietraeger_tid || null;
            const energietraeger: string = (waerme_energietraeger.find((item: any) => item.tid === energietraeger_tid) || {}).name
                || maschine.energiedaten_waerme_energietraeger_tid || null;
            const messwert_unterzaehler: number = +maschine.messwert_unterzaehler || 0;
            let energieverbrauch: number = 0;

            if (messwert_unterzaehler > 0) {
                energieverbrauch = messwert_unterzaehler;
            } else if (maschine.tid) {
                const leistung: number = +maschine.leistung || 0;
                const betriebszeit_h_tag: number = +maschine.betriebszeit_h_tag || 0;
                const betriebszeit_tage_jahr: number = +maschine.betriebszeit_tage_jahr || 0;
                const auslastungsfaktor: number = +maschine.auslastungsfaktor || 0;
                energieverbrauch = this.getEnergieverbrauch(
                    leistung, betriebszeit_h_tag, betriebszeit_tage_jahr, (auslastungsfaktor / 100)
                );
            }

            if (!maschine.tid) {
                data[energietraeger === 'Strom' ? 'strom' : 'waerme'].verbrauch += +maschine._energieverbrauch;
            }

            if (energietraeger === 'Strom') {
                data.strom.verbrauch += energieverbrauch;
            } else if (energietraeger !== 'Strom') {
                data.waerme.verbrauch += energieverbrauch;
            }
        });
        data.strom.anteil = (data.strom.total || 0) > 0 ? (data.strom.verbrauch / data.strom.total) * 100 : null;
        data.waerme.anteil = (data.waerme.total || 0) > 0 ? (data.waerme.verbrauch / data.waerme.total) * 100 : null;
        const columns: JSX.Element[][] = [[], [], []];

        Object.keys(data).forEach((key: string) => {
            const name: string = key === 'strom' ? 'STROM' : 'WÄRME';
            const typ: any = data[key] || {};
            columns[0].push(<>
                <div style={cell2}>
                    {name} - Verbrauch laut Anlagenliste (vgl. oben)
                </div>
                <div style={{ ...cell, fontStyle: 'italic' }}>
                    {name} - Tatsächlicher Verbrauch (laut Rechnungen){typ.jahr ? `; Jahr: ${typ.jahr}` : ''}
                </div>
            </>);
            columns[1].push(<>
                <div style={{ ...cell2, paddingRight: 12 }}>
                    {typ.anteil ? `${fn0nZ(typ.anteil)}%` : <>&nbsp;</>}
                </div>
                <div style={{ ...cell, paddingRight: 12 }}>
                    100%
                </div>
            </>);
            columns[2].push(<>
                <div style={cell2}>
                    {fn0nZ(typ.verbrauch)} kWh
                </div>
                <div style={cell}>
                    {fn0nZ(typ.total)} kWh
                </div>
            </>);
        });

        return (
            <div
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
                <div
                    style={{ fontSize: 12, display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap', width: '40%' }}
                >
                    <div style={{ flex: 1 }}>{...columns[0]}</div>
                    <div style={{ flex: 0, textAlign: 'right' }}>{...columns[1]}</div>
                    <div style={{ flex: 0, textAlign: 'right' }}>{...columns[2]}</div>
                </div>
            </div>
        );
    }

    renderImport(): JSX.Element {
        return (
            <>
                <WActionButton
                    label='Import abbrechen'
                    insideText='Import abbrechen'
                    key='cancel'
                    action='cancel'
                    onAction={() => this.setState({ beforeImportTids: [], showImportTool: false })}
                />
                <ZusatztoolsImport
                    data={this.props.data}
                    modul={IDs.MOD_ETOOL}
                    IDs={IDs}
                    entity={IDs.ENT_MASCHINEN}
                    onFinish={() => this.triggerService.fire('reload', IDs.ENT_MASCHINEN, () => this.checkImport())}
                    standort={this.props.standortSelected}
                    whitelistStructures={[IDs.ENT_MASCHINEN]}
                />
            </>
        );
    }

    renderImportButton(): JSX.Element {
        return (
            <WActionButton
                label='Import'
                insideText='Import'
                tooltip='Import aus Excel'
                key='import'
                action='import'
                onAction={() =>
                    this.setState({
                        beforeImportTids: ((this.props.data || {})[IDs.ENT_MASCHINEN] || []).map((item: any) => item.tid),
                        showImportTool: true
                    })
                }
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        if (key === 'status') {
            this.setState({ hiddenFormFields: +value !== 2 ? ['jahr_status'] : [] });
        }

        return validateFieldUniversal(IDs.ENT_MASCHINEN, key, value, data, onValueChange, this.props.data);
    }

    customFormConfigFunc(formConfig: any, formData: any) {
        if (formConfig && formConfig.items && formData && formData.values) {
            const { standortSelected } = this.props;
            const standortConfigIdx = (formConfig.items || []).findIndex((c: any) => c.key === 'standort_tid');
            if (standortConfigIdx >= 0) {
                formConfig.items[standortConfigIdx].readonly = false;
                if ((standortSelected && standortSelected.tid > 0) || formData.values.standort_tid > 0) {
                    formConfig.items[standortConfigIdx].readonly = true;
                }
            }
        }
    }
}
